function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import ReactDOM from "react-dom";
import React from "react"; // import withDialog from "./enhancers/withDialog";

import { Dialog } from "@blueprintjs/core";
import { nanoid } from "nanoid"; //this is only really useful for unconnected standalone simple dialogs
//remember to pass usePortal={false} to the <Dialog/> component so it will close properly

export default function showDialogOnDocBody(DialogComp, options) {
  if (options === void 0) {
    options = {};
  }

  var dialogHolder = document.createElement("div");
  var className = "myDialog" + nanoid();
  dialogHolder.className = className;
  document.body.appendChild(dialogHolder);

  var onClose = function onClose() {
    document.querySelector("." + className).remove();
  };

  var DialogCompToUse;

  if (options.addDialogContainer) {
    DialogCompToUse = function DialogCompToUse(props) {
      return /*#__PURE__*/React.createElement(Dialog, _extends({
        usePortal: false,
        title: "pass a {title} prop",
        isOpen: true
      }, props), /*#__PURE__*/React.createElement(DialogComp, _extends({}, props, {
        hideModal: onClose,
        onClose: onClose
      })));
    };
  } else {
    DialogCompToUse = DialogComp;
  }

  ReactDOM.render( /*#__PURE__*/React.createElement(DialogCompToUse, _extends({
    hideModal: onClose,
    onClose: onClose
  }, options)), dialogHolder);
}